module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2019/august-95dfe023cfb2351b1808f3c36ef2ab75.png";